import { Actions } from 'vuex-smart-module';
import { AxiosResponse } from 'axios';
import { ResponseStatuses } from '@/enums';
import BrandsGetters from './getters';
import BrandsMutations from './mutations';
import BrandsState from './state';
import { BrandPortalService } from '../services';

const brandPortalService = new BrandPortalService();

export default class BrandsActions extends Actions<
  BrandsState,
  BrandsGetters,
  BrandsMutations,
  // eslint-disable-next-line no-use-before-define
  BrandsActions
> {
  async get_public_info() {
    try {
      const { data, code = ResponseStatuses.Fail.FORBIDDEN } = await brandPortalService.get_public_info();

      if (data.banner) {
        this.mutations.SET_BANNER(data.banner);
      }
      if (data.design) {
        this.mutations.SET_BRANDS_DESING(data.design);
      }
      if (data.partnership) {
        this.mutations.SET_PARTNERSHIP(data.partnership);
      }
      if (data.brand) {
        this.mutations.SET_BRAND(data.brand);
      }
      return code;
    } catch (error) {
      console.error(error);
      return (error as AxiosResponse).status;
    }
  }

  async get_disign_by_id(id: string | number) {
    try {
      const { data, code = ResponseStatuses.Fail.FORBIDDEN } = await brandPortalService.get_disign_by_id(id);

      this.mutations.SET_DESIGN_TITLE(data.title);
      this.mutations.SET_DESIGN_PAGE_LIST(data.design_page_list);
      this.mutations.SET_DESIGN_BLOCK(data.blocks);
      this.mutations.UPD_ACTIVE_ID(id);
      return code;
    } catch (error) {
      console.error(error);
      return (error as AxiosResponse).status;
    }
  }
}
